// components/Teams/TeamsList.js
import React from 'react';
import TeamCard from './TeamCard';

const TeamsList = ({ 
  teams, 
  selectedTeam, 
  onSelectTeam, 
  onEditTeam, 
  onDeleteTeam,
  onCreateTeam,
  currentUserId,
  onExitTeam 
}) => {
  return (
    <div className="teams-list-section">
      <div className="section-header">
        <h2 className="section-title">Your Teams</h2>
        <button 
          className="create-team-btn"
          onClick={onCreateTeam}
        >
          + New Team
        </button>
      </div>
      
      <div className="teams-list">
        {teams.length === 0 ? (
          <div className="empty-teams">
            <div className="empty-icon">👥</div>
            <h3>No Teams Yet</h3>
            <p>Create your first team to get started</p>
          </div>
        ) : (
          teams.map(team => (
            <TeamCard
              key={team.team_id}
              team={{ ...team, currentUserId }}
              isSelected={selectedTeam?.team_id === team.team_id}
              onSelect={onSelectTeam}
              onEdit={onEditTeam}
              onDelete={onDeleteTeam}
              onExitTeam={onExitTeam}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default TeamsList;